// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file devtool/emodel/v1/pfe_model.proto (package devtool.emodel.v1, syntax proto3)
/* eslint-disable */

// A verbatim mirror of eModel's pfe_model.proto (enechain/service-proto,
// services/emodel/emodel/v1), in a package this repository owns: eposition-app's
// protos do not import another service's protos, but the dev-tool RPCs carry
// eModel requests and responses as their own.
//
// Field numbers and types match emodel.v1 exactly. That is what lets
// devtoolemodel.Convert translate by re-encoding instead of copying field by
// field, so any change to eModel's messages has to be mirrored here by hand —
// TestMirrorMatchesEmodel fails if the two ever drift.

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import type { BusinessDayConvention, Calendar, CollateralInfo, DayCounter, Frequency, PayReceive } from "./common_model_pb";
import { file_devtool_emodel_v1_common_model } from "./common_model_pb";
import type { CommodityFloatingLegData, IborFloatingLegData } from "./market_model_pb";
import { file_devtool_emodel_v1_market_model } from "./market_model_pb";
import type { Date } from "../../../google/type/date_pb";
import { file_google_type_date } from "../../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file devtool/emodel/v1/pfe_model.proto.
 */
export const file_devtool_emodel_v1_pfe_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_devtool_emodel_v1_common_model, file_devtool_emodel_v1_market_model, file_google_type_date]);

/**
 * ScheduleData represents a simplified schedule definition (ORE-style).
 *
 * @generated from message devtool.emodel.v1.ScheduleData
 */
export type ScheduleData = Message<"devtool.emodel.v1.ScheduleData"> & {
  /**
   * @generated from field: google.type.Date start_date = 1;
   */
  startDate?: Date;

  /**
   * @generated from field: google.type.Date end_date = 2;
   */
  endDate?: Date;

  /**
   * @generated from field: devtool.emodel.v1.Frequency frequency = 3;
   */
  frequency: Frequency;

  /**
   * @generated from field: devtool.emodel.v1.Calendar calendar = 4;
   */
  calendar: Calendar;

  /**
   * @generated from field: devtool.emodel.v1.BusinessDayConvention convention = 5;
   */
  convention: BusinessDayConvention;

  /**
   * Payment lag in calendar days (optional, default: 0).
   *
   * @generated from field: optional int32 payment_lag_days = 6;
   */
  paymentLagDays?: number;

  /**
   * End-of-month rule (optional, default: false).
   *
   * @generated from field: optional bool end_of_month = 7;
   */
  endOfMonth?: boolean;
};

/**
 * Describes the message devtool.emodel.v1.ScheduleData.
 * Use `create(ScheduleDataSchema)` to create a new message.
 */
export const ScheduleDataSchema: GenMessage<ScheduleData> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_model, 0);

/**
 * FloatingIndex identifies the market index used for floating legs (ORE-style).
 *
 * @generated from message devtool.emodel.v1.FloatingIndex
 */
export type FloatingIndex = Message<"devtool.emodel.v1.FloatingIndex"> & {
  /**
   * Index name, e.g. "COMM-POWER_JP_TOKYO_BASE"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Fixing lag in calendar days (optional, default: 0).
   *
   * @generated from field: optional int32 fixing_lag_days = 2;
   */
  fixingLagDays?: number;
};

/**
 * Describes the message devtool.emodel.v1.FloatingIndex.
 * Use `create(FloatingIndexSchema)` to create a new message.
 */
export const FloatingIndexSchema: GenMessage<FloatingIndex> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_model, 1);

/**
 * @generated from message devtool.emodel.v1.FixedLegData
 */
export type FixedLegData = Message<"devtool.emodel.v1.FixedLegData"> & {
  /**
   * Fixed price/strike. Unit depends on product (e.g. JPY/kWh).
   *
   * @generated from field: double fixed_price = 1;
   */
  fixedPrice: number;
};

/**
 * Describes the message devtool.emodel.v1.FixedLegData.
 * Use `create(FixedLegDataSchema)` to create a new message.
 */
export const FixedLegDataSchema: GenMessage<FixedLegData> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_model, 2);

/**
 * @generated from message devtool.emodel.v1.FloatingLegData
 */
export type FloatingLegData = Message<"devtool.emodel.v1.FloatingLegData"> & {
  /**
   * @generated from field: devtool.emodel.v1.FloatingIndex index = 1;
   */
  index?: FloatingIndex;

  /**
   * Optional spread added to the index.
   *
   * @generated from field: optional double spread = 2;
   */
  spread?: number;

  /**
   * Optional gearing applied to the index (default 1.0 if unset).
   *
   * @generated from field: optional double gearing = 3;
   */
  gearing?: number;
};

/**
 * Describes the message devtool.emodel.v1.FloatingLegData.
 * Use `create(FloatingLegDataSchema)` to create a new message.
 */
export const FloatingLegDataSchema: GenMessage<FloatingLegData> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_model, 3);

/**
 * LegData represents one cashflow leg (ORE-style).
 *
 * @generated from message devtool.emodel.v1.LegData
 */
export type LegData = Message<"devtool.emodel.v1.LegData"> & {
  /**
   * @generated from field: devtool.emodel.v1.PayReceive pay_receive = 1;
   */
  payReceive: PayReceive;

  /**
   * Underlying symbol string used to map to market data.
   * Format: {AREA}_{HOURTYPE}_{TENOR} e.g. "TOKYO_BASE_1"
   *
   * @generated from field: string symbol = 2;
   */
  symbol: string;

  /**
   * Quantity in kWh (positive quantity; direction is given by pay_receive).
   *
   * @generated from field: double quantity_kwh = 3;
   */
  quantityKwh: number;

  /**
   * @generated from field: devtool.emodel.v1.ScheduleData schedule = 4;
   */
  schedule?: ScheduleData;

  /**
   * @generated from field: devtool.emodel.v1.DayCounter day_counter = 5;
   */
  dayCounter: DayCounter;

  /**
   * @generated from oneof devtool.emodel.v1.LegData.coupon
   */
  coupon: {
    /**
     * @generated from field: devtool.emodel.v1.FixedLegData fixed = 10;
     */
    value: FixedLegData;
    case: "fixed";
  } | {
    /**
     * @generated from field: devtool.emodel.v1.FloatingLegData floating = 11;
     */
    value: FloatingLegData;
    case: "floating";
  } | {
    /**
     * @generated from field: devtool.emodel.v1.IborFloatingLegData ibor_floating = 12;
     */
    value: IborFloatingLegData;
    case: "iborFloating";
  } | {
    /**
     * @generated from field: devtool.emodel.v1.CommodityFloatingLegData commodity_floating = 13;
     */
    value: CommodityFloatingLegData;
    case: "commodityFloating";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message devtool.emodel.v1.LegData.
 * Use `create(LegDataSchema)` to create a new message.
 */
export const LegDataSchema: GenMessage<LegData> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_model, 4);

/**
 * MultiLeg represents a generic multi-leg trade (ORE-style).
 *
 * @generated from message devtool.emodel.v1.MultiLeg
 */
export type MultiLeg = Message<"devtool.emodel.v1.MultiLeg"> & {
  /**
   * @generated from field: repeated devtool.emodel.v1.LegData legs = 1;
   */
  legs: LegData[];
};

/**
 * Describes the message devtool.emodel.v1.MultiLeg.
 * Use `create(MultiLegSchema)` to create a new message.
 */
export const MultiLegSchema: GenMessage<MultiLeg> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_model, 5);

/**
 * Envelope holds trade meta information (ORE-style).
 *
 * @generated from message devtool.emodel.v1.Envelope
 */
export type Envelope = Message<"devtool.emodel.v1.Envelope"> & {
  /**
   * Netting set id (optional).
   *
   * @generated from field: string netting_set_id = 1;
   */
  nettingSetId: string;
};

/**
 * Describes the message devtool.emodel.v1.Envelope.
 * Use `create(EnvelopeSchema)` to create a new message.
 */
export const EnvelopeSchema: GenMessage<Envelope> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_model, 6);

/**
 * Trade represents a single trade entry for PFE calculation (ORE-style).
 *
 * v0 currently supports symbol-based power positions in FAST_VOLATILITY mode.
 *
 * @generated from message devtool.emodel.v1.Trade
 */
export type Trade = Message<"devtool.emodel.v1.Trade"> & {
  /**
   * Trade id (recommended).
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Trade type (recommended).
   *
   * @generated from field: devtool.emodel.v1.TradeType trade_type = 2;
   */
  tradeType: TradeType;

  /**
   * Envelope (optional).
   *
   * @generated from field: devtool.emodel.v1.Envelope envelope = 3;
   */
  envelope?: Envelope;

  /**
   * Multi-leg definition (recommended for swaps/spreads etc.).
   *
   * @generated from field: devtool.emodel.v1.MultiLeg multi_leg = 6;
   */
  multiLeg?: MultiLeg;
};

/**
 * Describes the message devtool.emodel.v1.Trade.
 * Use `create(TradeSchema)` to create a new message.
 */
export const TradeSchema: GenMessage<Trade> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_model, 7);

/**
 * @generated from message devtool.emodel.v1.ScenarioDataSet
 */
export type ScenarioDataSet = Message<"devtool.emodel.v1.ScenarioDataSet"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: bool is_active = 4;
   */
  isActive: boolean;

  /**
   * Optional start date (derived from start_at).
   *
   * @generated from field: optional google.type.Date start_date = 5;
   */
  startDate?: Date;
};

/**
 * Describes the message devtool.emodel.v1.ScenarioDataSet.
 * Use `create(ScenarioDataSetSchema)` to create a new message.
 */
export const ScenarioDataSetSchema: GenMessage<ScenarioDataSet> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_model, 8);

/**
 * MarketQuote provides base market inputs (ORE "todaysmarket" style, simplified).
 *
 * @generated from message devtool.emodel.v1.MarketQuote
 */
export type MarketQuote = Message<"devtool.emodel.v1.MarketQuote"> & {
  /**
   * Quote name. For v0 repricing we use symbol strings: {AREA}_{HOURTYPE}_{TENOR}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Quote value (e.g. price).
   *
   * @generated from field: double value = 2;
   */
  value: number;
};

/**
 * Describes the message devtool.emodel.v1.MarketQuote.
 * Use `create(MarketQuoteSchema)` to create a new message.
 */
export const MarketQuoteSchema: GenMessage<MarketQuote> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_model, 9);

/**
 * ScenarioSelection allows caller to control which scenario samples are used.
 * v0 "FAST_VOLATILITY" uses dataset samples as scenarios; this selects a subset.
 *
 * @generated from message devtool.emodel.v1.ScenarioSelection
 */
export type ScenarioSelection = Message<"devtool.emodel.v1.ScenarioSelection"> & {
  /**
   * If set, use only first N samples (after aligning symbols by minimum sample count).
   *
   * @generated from field: optional int32 num_samples = 1;
   */
  numSamples?: number;

  /**
   * If set, use specific sample indices (0-based) from the dataset.
   * When provided, this takes precedence over num_samples.
   *
   * @generated from field: repeated int32 sample_indices = 2;
   */
  sampleIndices: number[];

  /**
   * For historical scenarios: select scenarios by date range (inclusive).
   * If either is set, server filters dataset sample dates.
   *
   * @generated from field: optional google.type.Date start_date = 3;
   */
  startDate?: Date;

  /**
   * @generated from field: optional google.type.Date end_date = 4;
   */
  endDate?: Date;
};

/**
 * Describes the message devtool.emodel.v1.ScenarioSelection.
 * Use `create(ScenarioSelectionSchema)` to create a new message.
 */
export const ScenarioSelectionSchema: GenMessage<ScenarioSelection> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_model, 10);

/**
 * ScenarioInfo reports which scenario samples were used in the calculation.
 *
 * @generated from message devtool.emodel.v1.ScenarioInfo
 */
export type ScenarioInfo = Message<"devtool.emodel.v1.ScenarioInfo"> & {
  /**
   * Calculation mode used.
   *
   * @generated from field: devtool.emodel.v1.PFECalculationMode calculation_mode = 1;
   */
  calculationMode: PFECalculationMode;

  /**
   * Number of samples available in the dataset (after alignment).
   *
   * @generated from field: int32 num_samples_available = 3;
   */
  numSamplesAvailable: number;

  /**
   * Number of samples actually used.
   *
   * @generated from field: int32 num_samples_used = 4;
   */
  numSamplesUsed: number;

  /**
   * Sample indices actually used (0-based, refers to dataset indices).
   *
   * @generated from field: repeated int32 sample_indices_used = 5;
   */
  sampleIndicesUsed: number[];

  /**
   * Scenario dates actually used (for historical scenarios; optional).
   *
   * @generated from field: repeated google.type.Date scenario_dates_used = 6;
   */
  scenarioDatesUsed: Date[];

  /**
   * Scenario source used.
   *
   * @generated from field: devtool.emodel.v1.ScenarioSource scenario_source = 7;
   */
  scenarioSource: ScenarioSource;

  /**
   * Scenario dataset id resolved by server (preferred).
   *
   * @generated from field: string scenario_data_set_id = 8;
   */
  scenarioDataSetId: string;

  /**
   * Discounting was enabled for NPV calculation.
   *
   * @generated from field: bool discounting_enabled = 9;
   */
  discountingEnabled: boolean;

  /**
   * Collateral simulation was enabled.
   *
   * @generated from field: bool collateral_enabled = 10;
   */
  collateralEnabled: boolean;

  /**
   * Collateral settings actually used (for UI verification).
   *
   * @generated from field: optional devtool.emodel.v1.CollateralInfo collateral_info = 11;
   */
  collateralInfo?: CollateralInfo;
};

/**
 * Describes the message devtool.emodel.v1.ScenarioInfo.
 * Use `create(ScenarioInfoSchema)` to create a new message.
 */
export const ScenarioInfoSchema: GenMessage<ScenarioInfo> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_model, 11);

/**
 * DiscountingConfig controls discounting in REPRICING mode.
 * Default behavior is discounting disabled (DF=1).
 *
 * @generated from message devtool.emodel.v1.DiscountingConfig
 */
export type DiscountingConfig = Message<"devtool.emodel.v1.DiscountingConfig"> & {
  /**
   * If true, apply discount factors to cashflows.
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * Flat continuously-compounded rate (e.g. 0.02 for 2%).
   * Required when enabled=true.
   *
   * @generated from field: optional double flat_rate = 2;
   */
  flatRate?: number;
};

/**
 * Describes the message devtool.emodel.v1.DiscountingConfig.
 * Use `create(DiscountingConfigSchema)` to create a new message.
 */
export const DiscountingConfigSchema: GenMessage<DiscountingConfig> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_model, 12);

/**
 * QuantileResult contains PFE values for a single quantile.
 *
 * @generated from message devtool.emodel.v1.QuantileResult
 */
export type QuantileResult = Message<"devtool.emodel.v1.QuantileResult"> & {
  /**
   * The quantile value in basis points (1/10000).
   * e.g., 99.9% = 9990, 99% = 9900, 95% = 9500.
   *
   * @generated from field: int32 quantile = 1;
   */
  quantile: number;

  /**
   * Daily PFE values for this quantile (length = evaluation_days).
   *
   * @generated from field: repeated double values = 2;
   */
  values: number[];
};

/**
 * Describes the message devtool.emodel.v1.QuantileResult.
 * Use `create(QuantileResultSchema)` to create a new message.
 */
export const QuantileResultSchema: GenMessage<QuantileResult> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_model, 13);

/**
 * TradeType identifies trade category (ORE-style tradeType).
 *
 * @generated from enum devtool.emodel.v1.TradeType
 */
export enum TradeType {
  /**
   * @generated from enum value: TRADE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRADE_TYPE_POWER_POSITION = 1;
   */
  POWER_POSITION = 1,

  /**
   * @generated from enum value: TRADE_TYPE_POWER_SWAP = 2;
   */
  POWER_SWAP = 2,

  /**
   * @generated from enum value: TRADE_TYPE_POWER_SPREAD = 3;
   */
  POWER_SPREAD = 3,

  /**
   * @generated from enum value: TRADE_TYPE_MULTI_LEG = 4;
   */
  MULTI_LEG = 4,
}

/**
 * Describes the enum devtool.emodel.v1.TradeType.
 */
export const TradeTypeSchema: GenEnum<TradeType> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_pfe_model, 0);

/**
 * PFECalculationMode specifies how scenarios/NPV are generated.
 * This mirrors ORE-style separation of scenario generation vs pricing engine.
 *
 * @generated from enum devtool.emodel.v1.PFECalculationMode
 */
export enum PFECalculationMode {
  /**
   * @generated from enum value: PFE_CALCULATION_MODE_UNSPECIFIED = 0;
   */
  PFE_CALCULATION_MODE_UNSPECIFIED = 0,

  /**
   * Fast/approx: volatility scenario samples -> NPV-like values (no full repricing).
   *
   * @generated from enum value: PFE_CALCULATION_MODE_FAST_VOLATILITY = 1;
   */
  PFE_CALCULATION_MODE_FAST_VOLATILITY = 1,

  /**
   * Full repricing (reserved for future v0 extension).
   *
   * @generated from enum value: PFE_CALCULATION_MODE_REPRICING = 2;
   */
  PFE_CALCULATION_MODE_REPRICING = 2,
}

/**
 * Describes the enum devtool.emodel.v1.PFECalculationMode.
 */
export const PFECalculationModeSchema: GenEnum<PFECalculationMode> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_pfe_model, 1);

/**
 * ScenarioSource specifies what dataset is used as scenario input.
 * - VOLATILITY: dataset values are interpreted as sigma samples (current v0 fast mode)
 * - HISTORICAL: dataset values are interpreted as historical prices (historical scenarios)
 *
 * @generated from enum devtool.emodel.v1.ScenarioSource
 */
export enum ScenarioSource {
  /**
   * @generated from enum value: SCENARIO_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SCENARIO_SOURCE_VOLATILITY = 1;
   */
  VOLATILITY = 1,

  /**
   * @generated from enum value: SCENARIO_SOURCE_HISTORICAL = 2;
   */
  HISTORICAL = 2,
}

/**
 * Describes the enum devtool.emodel.v1.ScenarioSource.
 */
export const ScenarioSourceSchema: GenEnum<ScenarioSource> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_pfe_model, 2);

